var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',_vm._l((_vm.tests),function(test){return _c('v-col',[_c('v-btn',{attrs:{"elevation":"2","to":test.to}},[_vm._v(_vm._s(test.caption))])],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }